module.exports = __webpack_public_path__ + "img/zoom.5d758062.svg";